var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.145,
    height: 14.145
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 609",
    d: "M7.78 13.436a1 1 0 01-1.415 0 1 1 0 010-1.414l4.95-4.95-4.95-4.95a1 1 0 010-1.414 1 1 0 011.414 0l5.657 5.657a1 1 0 010 1.414z",
    fill: "#898991"
  })));
}
export default SvgPaginationArrowRight;